// extracted by mini-css-extract-plugin
module.exports = {"root":"map-marker-module_root_1T_OO"};